<template>
  <div class="photos">
    <div class="photo" v-for="photo in filteredPhotos" :key="photo.id">
      <img v-bind:src="photo.path" alt="" />
      <div>{{ photo.title }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Photos",
  data() {
    return {
      search: ""
    };
  },
  methods: {
    ...mapActions(["fetchPhotos"])
  },
  computed: {
    ...mapGetters(["allPhotos"]),
    filteredPhotos: function() {
      return this.allPhotos.filter(photo => {
        return photo.title.match(this.search);
      });
    }
  },
  created() {
    this.fetchPhotos();
  }
};
</script>

<style>
.photos {
  display: grid;
  grid-template-columns: auto auto;
  gap: 10px;
  margin-top: 20px;
  padding-bottom: 20px;
}

.photo {
  text-align: center;
}
</style>
